import React, { Component } from 'react';

export class NatureIncident extends Component {

    //handleNatureIncidentChange = (e) => {
        //const name = e.target.name;
        //const value = e.target.value;

        //this.props.specificChanges(e);
    //}

    render() {
        return (
            <div className="form-horizontal row spacer">
                <label className="control-label col-sm-4" htmlFor="Source">What was the nature of the incident?</label>
                <div className="col-sm-8">
                    <textarea className="form-control" type="text" name="natureIncident" onBlur={this.props.specificChanges} maxLength={500}></textarea>
                </div>
            </div >
        );
    }
}
export default NatureIncident;


// WEBPACK FOOTER //
// ./src/components/questions/NatureIncident.jsx